import * as types from './types';

export const appSetIsReady = isReady => ({
  type: types.APP_SET_IS_READY,
  payload: {
    isReady,
  },
});

export const appSetSessionId = sessionId => ({
  type: types.APP_SET_SESSION_ID,
  payload: {
    sessionId,
  },
});



// WEBPACK FOOTER //
// ./src/actions/app/actions.js